import { Component, OnInit, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'app-monitored-train-canvas',
  template: require('./monitored-train-canvas.component.html'),
  styles: [require('./monitored-train-canvas.component.sass')]
})
export class MonitoredTrainCanvasComponent  extends UpgradeComponent {

  @Input() train: any;
  // TODO this is an angularJS component upgraded to Angular component
  constructor(elementRef: ElementRef, injector: Injector) {
    super('trainCanvas', elementRef, injector);
  }

}
